module.exports = __webpack_public_path__ + "img/img5.6d0f3e3d.png";